import type { QueryKey } from '@tanstack/react-query';

export type ClinicalFormScope = { encounterId: string } | { admissionId: string };

export function clinicalFormsPath(scope: ClinicalFormScope): string {
  return 'encounterId' in scope ? `/encounters/${scope.encounterId}/forms` : `/ipd/admissions/${scope.admissionId}/forms`;
}

export function clinicalFormsKey(scope: ClinicalFormScope): QueryKey {
  return 'encounterId' in scope ? ['encounter-forms', scope.encounterId] : ['admission-forms', scope.admissionId];
}

export function clinicalFormKeysToRefresh(scope: ClinicalFormScope): QueryKey[] {
  return 'encounterId' in scope ? [clinicalFormsKey(scope), ['encounter', scope.encounterId]] : [clinicalFormsKey(scope)];
}
